export default __webpack_public_path__ + "static/media/speed-banners.f99f58db.webp";